import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
import { Router } from '@angular/router';
//import { AngularEditorConfig } from '@kolkov/angular-editor';

import { AuthService, DataService } from '../../_services';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.css']
})
export class TemplatesComponent implements OnInit {
  pageData = {
    viewMode: 'LIST',
    actionMode: 'NEW',
    records: []
  };
  htmlContent = '';
  oRec:any = {}
  constructor(
    private router: Router,
    private changeDetector : ChangeDetectorRef,
    private svcData: DataService
  ) { }

  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   //height: '25rem',
  //   minHeight: '10rem',
  //   placeholder: 'Enter text here...',
  //   translate: 'no',
  //   uploadUrl: 'v1/images', // if needed
  //   customClasses: [ // optional
  //     {
  //       name: "quote",
  //       class: "quote",
  //     },
  //     {
  //       name: 'redText',
  //       class: 'redText'
  //     },
  //     {
  //       name: "titleText",
  //       class: "titleText",
  //       tag: "h1",
  //     },
  //   ]
  // };

  ngOnInit() {
    this.dataBind();
  }
  dataBind(){
    this.svcData.templateList('EML').subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.records = res.data;
    });
  }
  recordAdd(){
    this.oRec = {};
    this.pageData.viewMode = 'FORM';
    this.pageData.actionMode = 'NEW';
  }
  recordSave(){
    if(!this.oRec.templateCode){
      this.showAlert('Template Code should not be empty!');
      return;
    }
    if(!this.oRec.templateName){
      this.showAlert('Template Name should not be empty!');
      return;
    }
    if(!this.oRec.subject){
      this.showAlert('Subject should not be empty!');
      return;
    }
    if(!this.oRec.body){
      this.showAlert('Message Body should not be empty!');
      return;
    }
    if(this.pageData.actionMode == 'NEW'){
      this.oRec.templateType = 'EML';
      this.oRec.client = {clientId: ''};
      this.oRec.remark = '';
      this.svcData.templateCreate(this.oRec).subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.dataBind();
        this.viewList();
        this.showAlert('Information created successfully!');
      });
    }
    else{
      this.svcData.templateUpdateSubjectBody(this.oRec).subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.dataBind();
        this.viewList();
        this.showAlert('Information updated successfully!');
      });
    }
  }
  recordEdit(rec){
    this.pageData.actionMode = 'EDIT';
    this.pageData.viewMode = 'FORM';
    this.oRec = rec;
  }
  recordDelete(rec){
    if(!confirm(`Are you sure you want to delete the template "${rec.templateCode}"?`)) return;
    rec.status = 2;
    this.svcData.templateDelete(rec).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataBind();
      this.showAlert('Information deleted successfully!');
    });
  }
  viewList(){
    this.pageData.viewMode = 'LIST';
  }
  showAlert(msg){
    M.toast({html: msg});
  }
  goto = function(argRout){
    this.router.navigate([argRout]);
  }
}
